/**
 * 热点头条服务
 * 2017-11-19
 * Bai.Zhiming
 */
"use strict";
angular.module("hotFocusServiceModule", ["initHotHeadModule", 'showNetWorkModule', 'makeFastNewsModule', 'viewLayoutModule'])
    .factory('hotFocusService', ['$q', '$modal', function($q, $modal) {
        return {
            showNetWork: function(item) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./planningCenter/hotFocus/services/showNetWork/showNetWork_tpl.html",
                    windowClass: 'showNetWork-window',
                    backdrop: false,
                    controller: "showNetWorkCtrl",
                    resolve: {
                        item: function() {
                            return item;
                        }
                    }
                });
                //关闭弹窗
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
            },
            makeFastNews: function(item) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./planningCenter/hotFocus/services/makeFastNews/makeFastNews_tpl.html",
                    windowClass: 'makeFastNews-window',
                    backdrop: true,
                    controller: "makeFastNewsCtrl",
                    resolve: {
                        item: function() {
                            return item;
                        }
                    }
                });
                //关闭弹窗
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
            },
            viewLayout: function(item) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./planningCenter/hotFocus/services/viewLayout/viewLayout_tpl.html",
                    windowClass: 'viewLayout-window',
                    backdrop: true,
                    controller: "viewLayoutCtrl",
                    resolve: {
                        item: function() {
                            return item;
                        }
                    }
                });
                //关闭弹窗
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
            }
        };
    }]);